import { render, staticRenderFns } from "./WannasornTrialCourseInfo.vue?vue&type=template&id=f53dd61e&scoped=true"
import script from "./WannasornTrialCourseInfo.vue?vue&type=script&lang=js"
export * from "./WannasornTrialCourseInfo.vue?vue&type=script&lang=js"
import style0 from "./WannasornTrialCourseInfo.vue?vue&type=style&index=0&id=f53dd61e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53dd61e",
  null
  
)

export default component.exports